/**
 * Shows a back-to-top button after scrolling past a threshold.
 */
(function () {
  'use strict';

  function initBackToTop(button) {
    if (!button || button.dataset.nkBackToTopInit) return;
    button.dataset.nkBackToTopInit = 'true';

    var threshold = parseInt(button.dataset.scrollThreshold || '400', 10);
    if (Number.isNaN(threshold) || threshold < 0) {
      threshold = 400;
    }

    function updateVisibility() {
      var show = window.scrollY > threshold;
      button.hidden = !show;
      button.classList.toggle('is-visible', show);
    }

    button.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', updateVisibility, { passive: true });
    updateVisibility();
  }

  function initAll() {
    document.querySelectorAll('[data-nk-back-to-top]').forEach(initBackToTop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
